import { pipe, path, length, defaultTo } from 'ramda'
import { useSelector } from 'react-redux'

const useChatCount = () =>
  useSelector(pipe(path(['chat', 'unread_timeline_rooms']), defaultTo([]), length))

export default useChatCount
